<app-form-input
  [label]="'INPUT.PASSWORD.LABEL'"
  [inputType]="'password'"
  [required]="true"
  [appShowPassword]="true"
  [name]="'password'"
  [placeholder]="'INPUT.PASSWORD.PLACEHOLDER'"
  [(model)]="password"
  (modelChange)="checkPassword($event)"
  [errors]="errors"
  [shouldRenderErrors]="true"
>
</app-form-input>

@if (!isSimplePassword) {
  <ul class="rules">
    <li [class.valid]="hasMinLength">{{ lengthValidationText() | translate }}</li>
    <li [class.valid]="hasUppercase">{{ "PASSWORD_VALIDATOR.CONDITION_2" | translate }}</li>
    <li [class.valid]="hasSpecialChar">{{ "PASSWORD_VALIDATOR.CONDITION_3" | translate }}</li>
  </ul>
}
